import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { HeadingItem, HeadingPage, useBranding } from '@terra/ui-design-system';
import { HStack, VStack } from '@terra/ui-styled-system';
import iconOrange from '../../../../public/images/icon-orange.svg';
import { useCurrentUser } from '../../../hooks/useCurrentUser';

export function LauncherBrandHeader() {
  const t = useTranslations('home');
  const { brandName, logoUrl } = useBranding();
  const { name, isLoading } = useCurrentUser();
  const firstName = name?.trim().split(/\s+/)[0];

  return (
    <VStack gap="5" alignItems="flex-start">
      <HStack gap="1.5" alignItems="center">
        <Image
          src={logoUrl ?? iconOrange}
          alt={brandName}
          width={18}
          height={18}
          style={{ objectFit: 'contain' }}
        />
        <HeadingItem>{brandName}</HeadingItem>
      </HStack>
      <HeadingPage>
        {isLoading || !firstName
          ? t('welcomeBackAnonymous')
          : t('welcomeBack', { name: firstName })}
      </HeadingPage>
    </VStack>
  );
}
